import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Subheading({ size = 'small', colour, text, ...props }) {
  return (
    <p
      {...props}
      className={classNames('style', `style--sub-heading-${size}`, {
        [`sub-heading-${size}--${colour}`]: colour
      })}
    >
      {text}
    </p>
  );
}

Subheading.propTypes = {
  /**
   * The size
   */
  size: PropTypes.oneOf(['small']),
  /**
   * The colour
   */
  colour: PropTypes.oneOf(['grey', 'a', 'b']),
  /**
   * The text
   */
  text: PropTypes.string.isRequired
};

export default Subheading;
